import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router';

import { newPassWordDataType } from '../../models/auth/enterNewPassword.model';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../models/https';
import { ACCOUNT, PASSWORD_RESET_SUCCESS } from '../../routes/routeConstants';
import useHttps from '../useHttps';

const useSetNewPassword = () => {
  const navigate = useNavigate();
  const request = useHttps();
  const [loading, setLoading] = useState(false);

  const onResetPasswordError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(err?.response?.data?.message ?? 'Something went wrong');
  };

  const onResetUserPassword = (_: SuccessHttpResponse<any>) => {

    navigate(`/${ACCOUNT}/${PASSWORD_RESET_SUCCESS}`, {
      replace: true,
    });
  };

  const setNewPassword = (data: newPassWordDataType, b64uid: string, b64token: string) => {
    const url: HttpConfig = {
      url: 'auth-service/users/reset-password',
      method: 'patch',
      data: {
        ...data,
        b64uid,
        b64token,
      },
    };

    request(url, onResetUserPassword, setLoading, onResetPasswordError);
  };

  return {
    loading,
    setNewPassword,
  };
};

export default useSetNewPassword;
